(function () {
  angular
    .module("akitabox.mobile.directives.noteInput", ["akitabox.core"])
    .directive("abmNoteInput", AbmNoteInputDirective);

  /**
   * @ngdoc directive
   * @module akitabox.directives.noteInput
   * @name AbmNoteInputDirective
   *
   * @restrict E
   *
   * @description
   * `<abm-note-input>`
   *
   * @usage
   * <hljs lang="html">
   *
   * <abm-note-input>
   * </abm-note-input>
   *
   * </hljs>
   */
  function AbmNoteInputDirective() {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/note-input/note-input.html",
      replace: true,
      controller: AbmNoteInputController,
      controllerAs: "vm",
      bindToController: true,
      scope: {
        onSave: "&",
      },
    };
  }

  /**
   * @ngdoc controller
   * @module akitabox.mobile.directives.noteInput
   * @name AbmNoteInputController
   *
   * @description
   * Controller for the note input directive
   *
   * @ngInject
   */
  function AbmNoteInputController($q) {
    var self = this;
    // Attributes
    self.saving = false;
    self.noteText = null;

    // Functions
    self.save = save;

    function save() {
      self.saving = true;

      $q.resolve(self.onSave({ noteText: self.noteText }))
        .then(function () {
          self.noteText = null;
        })
        .finally(function () {
          self.saving = false;
        });
    }
  }
})();
